<template>
  <div>
    <form class="md:flex md:align-top" @submit.prevent="submitFilters">
      <div
        class="mb-16 grid flex-1 grid-cols-2 gap-16 overflow-hidden lg:grid-cols-4"
        :class="{ 'max-h-56': !shouldShowAllFilters }"
      >
        <RevInputText
          v-if="shouldShowFilter(FILTER_FIELDS.TITLE)"
          :id="FILTER_FIELDS.TITLE"
          v-model="filtersValues.title"
          :label="i18n(sharedTranslations.title)"
          type="text"
        />
        <RevInputText
          v-if="shouldShowFilter(FILTER_FIELDS.SKU)"
          :id="FILTER_FIELDS.SKU"
          v-model="filtersValues.sku"
          :label="i18n(sharedTranslations.sku)"
          type="text"
        />
        <RevInputSelect
          v-if="shouldShowFilter(FILTER_FIELDS.BACKBOX)"
          :id="FILTER_FIELDS.BACKBOX"
          v-model="filtersValues.hasBackbox"
          :label="i18n(sharedTranslations.backbox)"
          :options="backboxOptions"
        />
        <RevInputSelect
          v-if="shouldShowFilter(FILTER_FIELDS.STOCK)"
          :id="FILTER_FIELDS.STOCK"
          v-model="filtersValues.hasStock"
          :label="i18n(sharedTranslations.stock)"
          :options="stockOptions"
        />
        <RevInputText
          v-if="shouldShowFilter(FILTER_FIELDS.UUID)"
          :id="FILTER_FIELDS.UUID"
          v-model="filtersValues.productId"
          :label="i18n(sharedTranslations.uuid)"
          type="text"
        />
        <RevInputText
          v-if="shouldShowFilter(FILTER_FIELDS.BACKMARKET_ID)"
          :id="FILTER_FIELDS.BACKMARKET_ID"
          v-model="filtersValues.bmId"
          :label="i18n(sharedTranslations.backmarketId)"
          type="text"
        />
        <RevInputSelect
          v-if="shouldShowFilter(FILTER_FIELDS.GRADE)"
          :id="FILTER_FIELDS.GRADE"
          v-model="filtersValues.aestheticGrade"
          :label="i18n(sharedTranslations.grade)"
          :options="gradesOptions"
        />
        <RevInputSelect
          v-if="shouldShowFilter(FILTER_FIELDS.ALERT)"
          :id="FILTER_FIELDS.ALERT"
          v-model="filtersValues.priceOverNew"
          :label="i18n(sharedTranslations.alerts)"
          :options="alertOptions"
        />
        <RevInputSelect
          v-if="shouldShowFilter(FILTER_FIELDS.MARKET)"
          :id="FILTER_FIELDS.MARKET"
          v-model="filtersValues.market"
          :label="i18n(sharedTranslations.market)"
          :options="availableMarketsOptions"
        />

        <SelectCategory v-model="filtersValues.categoryId" />

        <RevInputSelect
          v-if="shouldShowFilter(FILTER_FIELDS.HAS_NEW_BATTERY)"
          :id="FILTER_FIELDS.HAS_NEW_BATTERY"
          v-model="filtersValues.hasNewBattery"
          :label="i18n(sharedTranslations.hasNewBattery)"
          :options="hasNewBatteryOptions"
        />
      </div>
      <div class="ml-16">
        <RevButton type="submit" variant="primary">
          {{ i18n(sharedTranslations.submit) }}
        </RevButton>
        <RevLink class="ml-16" type="button" @click="resetFilters">
          {{ i18n(sharedTranslations.resetFilters) }}
        </RevLink>
      </div>
    </form>
    <div class="mb-8">
      <RevButton size="small" variant="secondary" @click="toggleMoreFilters">
        <template v-if="shouldShowAllFilters">
          {{ i18n(sharedTranslations.showLessFilters) }}
        </template>
        <template v-else>
          {{ i18n(sharedTranslations.showMoreFilters) }}
        </template>
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { RevLink } from '@ds/components/Link'

import SelectCategory from '../../../../../../../../components/Input/SelectCategory/SelectCategory.vue'
import { useFiltersOptions } from '../../../../composables/useFiltersOptions'
import { FILTER_FIELDS } from '../../Filters.constants'
import sharedTranslations from '../../Filters.translations'
import type { FilterValues } from '../../Filters.types'

const i18n = useI18n()

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

defineProps<{
  resetFilters: () => void
  submitFilters: () => void
  shouldShowFilter: (filter: string) => boolean
  shouldShowMissingActionFilter: boolean
  shouldShowOrderStateFilter: boolean
}>()

const {
  alertOptions,
  availableMarketsOptions,
  backboxOptions,
  gradesOptions,
  hasNewBatteryOptions,
  stockOptions,
} = useFiltersOptions()

const shouldShowAllFilters = ref(false)

function toggleMoreFilters() {
  shouldShowAllFilters.value = !shouldShowAllFilters.value
}
</script>
